import { Box, Grid, Button, TextField, CircularProgress } from "@mui/material";
import { FC, useState, useEffect } from "react";
import GoldTopBanner from "../../components/GoldTopBanner";
import SilverTopBanner from "../../components/SilverTopBanner";
import GradientCard from "../../components/GradientCard";
import { load, remove } from "../../constants/storage";
import { H3, H4, Small, H6 } from "../../components/Typography";
import FormatCurrency from "../../constants/formateCurrency";
import {
  getLivePrices,
  getInvestments,
  startInvestment,
} from "../../redux/actions/GoldSilverAction";
import { GOLD_SILVER_CATEGORY_TILES } from "../../constants/constant";
import { useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { PAYMENT_URL_DEV, MERCHANTS_ID } from "../../common/common";
interface DGSTabProps {
  type?: any;
}
const DigitalGoldTabScreen: FC<DGSTabProps> = ({ type }) => {
  const [metalType, setMetalType] = useState(type ? type : "Gold");
  const [selected, setSelected] = useState(1);
  const [goldLivePrice, setGoldLivePrice] = useState();
  const [silverLivePrice, setSilverLivePrice] = useState();
  const [loading, setLoading] = useState(true);
  const [goldGrowth, setGoldGrowth] = useState<any>();
  const [silverGrowth, setSilverGrowth] = useState<any>();
  const [totalGoldAmt, setTotalGoldAmt] = useState();
  const [totalGold, setTotalGold] = useState();
  const [totalSilverAmt, setTotalSilverAmt] = useState();
  const [totalSilver, setTotalSilver] = useState();
  const [goldCurrentValue, setGoldCurrentValue] = useState();
  const [silverCurrentValue, setSilverCurrentValue] = useState();
  const [goldAmount, setGoldAmount] = useState<any>();
  const [silverAmount, setFinalSilverPrice] = useState<any>();
  const [amount, setAmount] = useState<any>();
  const [goldGram, setGoldGram] = useState<string>("1");
  const [silverGram, setSilverGram] = useState<string>("2");
  const [goldPriceWithGst, setGoldPriceWithGst] = useState<any>();
  const [silverPriceWithGst, setSilverPriceWithGst] = useState<any>();
  let navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    checkToken();
  }, [metalType]);

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getPrices();
      getInvestmentsData();
    }
  };
  //Get Live Prices
  const getPrices = async () => {
    let token = await load("token");
    dispatch(getLivePrices(token))
      .then(async (response: any) => {
        setSilverLivePrice(response.sBuy);
        setGoldLivePrice(response.gBuy);

        let goldPriceGst =
          parseFloat(response.gBuy) + parseFloat(response.gBuyGst);
        setGoldAmount(goldPriceGst.toFixed(2));

        let silverPriceGst =
          parseFloat(response.sBuy) + parseFloat(response.sBuyGst);
        setFinalSilverPrice(parseFloat(silverPriceGst.toFixed(2)) * 2);

        let final =
          metalType === "Gold"
            ? goldPriceGst.toFixed(2)
            : metalType === "Silver"
            ? silverPriceGst.toFixed(2)
            : null;
        setAmount(final);

        if (metalType === "Gold") {
          setGoldPriceWithGst(goldPriceGst.toFixed(2));
          return;
        }
        if (metalType === "Silver") {
          setSilverPriceWithGst(silverPriceGst.toFixed(2));
          return;
        }
        setLoading(false);
      })
      .catch((error) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const handleBackButton = () => {
    return null;
  };
  useEffect(() => {
    const handleBrowserBackButton = (event: any) => {
      event.preventDefault();
      handleBackButton();
    };

    window.addEventListener("popstate", handleBrowserBackButton);

    return () => {
      window.removeEventListener("popstate", handleBrowserBackButton);
    };
  }, []);
  //Get Investments Prices
  const getInvestmentsData = async () => {
    let token = await load("token");
    const countryCode: any = "91";
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    var numberWithCode = countryCode + finalUser.mobile;
    dispatch(getInvestments(numberWithCode, token))
      .then(async (response: any) => {
        setTotalGold(response?.totalGold.toFixed(4) ?? "0");
        setTotalGoldAmt(response?.totalGoldAmt ?? "0");
        setTotalSilver(response?.totalSilver.toFixed(4) ?? "0");
        setTotalSilverAmt(response?.totalSilverAmt ?? "0");
        setGoldGrowth(response?.goldChangedBy ?? "0");
        setSilverGrowth(response?.silverChangedBy ?? "0");
        setSilverCurrentValue(response?.silverCurrentValue ?? "0");
        setGoldCurrentValue(response?.goldCurrentValue ?? "0");
        setLoading(false);
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  //Amount Edit
  const amountEdit: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;

    if (value > 100000) {
      toast.error("Amount should not be greater than 100000 rupees.");
      return;
    }
    if (value <= 100000) {
      var totalGram: any = value / amount;
      totalGram = totalGram.toFixed(4);

      // New Logic
      if (totalGram <= 500) {
        setGoldGram(totalGram);
        setSilverGram(totalGram);
        setGoldAmount(value);
        setFinalSilverPrice(value);
      } else {
        toast.error("Please enter less then 500 Gm.");
      }
    }
  };

  //Gram Edit
  const grmEdit: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event: any) => {
    const value = event.target.value;

    if (value > 500) {
      toast.error("Please enter less then 500 Gm.");
    } else {
      var totalAmmount: any = amount * value;
      var totalAmmount = totalAmmount.toFixed(2);
      if (totalAmmount <= 100000) {
        setGoldAmount(totalAmmount);
        setFinalSilverPrice(totalAmmount);
        setGoldGram(value);
        setSilverGram(value);
      } else {
        toast.error("Amount should not be greater then 100000 rupees.");
      }
    }
  };

  //Button
  const onButtonSelected = (item: any) => {
    var totalValue = item * amount;
    setGoldGram(item);
    setSilverGram(item);
    var totalAmmount = totalValue.toFixed(2);
    setGoldAmount(totalAmmount);
    setFinalSilverPrice(totalAmmount);
  };

  const onCardPress = (title: any) => {
    if (title === "Gift Gold/Silver") {
      navigate("/gifting");
      return;
    }
    if (title === "Sell") {
      navigate("/sellredeem", {
        state: {
          cardType: "Sell",
        },
      });
      return;
    }
    if (title === "Redeem") {
      navigate("/sellredeem", {
        state: {
          cardType: "Redeem",
        },
      });
      return;
    }
    if (title === "Gold Coins") {
      navigate("/goldcoin");
      return;
    }
  };

  const confirmInvest = async () => {
    setLoading(true);
    let token: any = load("token");
    let userDetail: any = load("userData");
    let user = JSON.parse(userDetail);
    const code = user.country_code ? user.country_code : "+91";
    var newValue = code.toString().slice(1);
    var ammount: string = metalType === "Gold" ? goldAmount : silverAmount;
    let totalWeight: any = metalType === "Gold" ? goldGram : silverGram;
    const data = {
      mobileNo: newValue + user.mobile,
      amount: ammount,
      quantity: parseFloat(totalWeight).toFixed(4),
      productId: metalType.toLowerCase(),
      name: user.firstname + " " + user.lastname,
      userId: user.id,
      source: "partner",
      callBackUrl: process.env.REACT_APP_GS_CALL_BACK_URL,
      partnerId: user?.refcode,
    };
    await dispatch(startInvestment(data, token))
      .then(async (response: any) => {
        if (response?.status === 401) {
          setLoading(false);
          return;
        }
        if (response.errorCode === "1006") {
          toast.error(response.errorMsg);
          setLoading(false);
          return;
        } else
        if (response.errorCode === "1007") {
          toast.error("Please check your internet connection.");
          setLoading(false);
        } else {
          let newWindow: any = window.open("", "_self");
          await newWindow.document.write(`
              <html>
                <head>
                  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
                  <title>Acru - Financial Wellness for All</title>
                </head>
                <body>
                  <div id="waiting" style="display: block; font-family: sans-serif;">
                    <br /><br />
                    <center><h1>Please wait!</h1><h2> Do not refresh the page</h2></center>
                  </div>
                  <div id="done" style="display: none; font-family: sans-serif;">
                    <br /><br />
                    <center><h2>Payment has been cancelled.</h2><h4><nav><a href="/dashboard">Retry</a></nav></h4></center>
                  </div>
                  <div id="paytm-checkoutjs"></div>
                  <script>
                    function hidewaiting() {
                      setTimeout(() => {
                        document.getElementById("waiting").style.display = "none";
                      }, 10000);
                    }
                    
                    function showdone() {
                      setTimeout(() => {
                        document.getElementById("done").style.display = "block";
                      }, 10000);
                    }
                    
                    function onScriptLoad() {
                      var config = {
                        root: "",
                        flow: "DEFAULT",
                        data: {
                          "orderId": "${response.orderId}",
                          "token": "${response.txnToken}",
                          "tokenType": "TXN_TOKEN",
                          "amount": "${response.amount}"
                        },
                        handler: {
                          notifyMerchant: function(eventName, data) {
                            console.log("eventName => ", eventName);
                            console.log("data => ", data);
                            if (eventName === "APP_CLOSED") {
                              showdone();
                              hidewaiting();
                              console.log("ddd");
                            } else {
                              showdone();
                            }
                            console.log("eventName => ", eventName);
                            console.log("data:::-->>", data.message);
                          }
                        },
                      };
                      
                      if (window.Paytm && window.Paytm.CheckoutJS) {
                        window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
                          window.Paytm.CheckoutJS.init(config)
                            .then(function onSuccess() {
                              window.Paytm.CheckoutJS.invoke();
                            })
                            .catch(function onError(error) {
                              console.log("error => ", error);
                            });
                        });
                      }
                      
                      window.history.pushState(null, null, window.location.href);
                      window.onpopstate = function() {
                        window.history.pushState(null, null, window.location.href);
                      };
                    }
            
                    var scriptTag = document.createElement("script");
                    scriptTag.type = "application/javascript";
                    scriptTag.crossOrigin = "anonymous";
                    scriptTag.src = "${PAYMENT_URL_DEV}/merchantpgpui/checkoutjs/merchants/${MERCHANTS_ID}.js";
                    scriptTag.onload = onScriptLoad;
            
                    document.body.appendChild(scriptTag);
                  </script>
                </body>
              </html>
            `);
          setLoading(false);
        }
      })
      .catch((error: any) => {
        console.log(
          "----------------- error self Invest-------dat------",
          error
        );
      });
  };

  return (
    <Grid
      sx={{
        pt: 2,
      }}
    >
      {loading ? (
        <Grid
          height="100vh"
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <>
          {metalType === "Gold" ? <GoldTopBanner /> : <SilverTopBanner />}
          <Grid
            container
            spacing={2}
            sx={{
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Grid xs={12} md={8} sx={sxStyleGrid}>
              <Grid
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: 2,
                }}
              >
                <Grid sx={sxStyleGrid1}>
                  <H3
                    sx={{
                      mt: 1,
                      pb: 1,
                      fontFamily: "'Poppins', sans-serif",
                      width: "90%",
                    }}
                  >
                    Investment Details
                  </H3>
                  <Box sx={sxStyleBox}>
                    <Button
                      onClick={() => {
                        setMetalType("Gold");
                        setAmount(goldPriceWithGst);
                        setGoldGram("1");
                        setSelected(1);
                      }}
                      disableElevation
                      disableRipple
                      size="medium"
                      sx={{
                        background:
                          metalType === "Gold"
                            ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                            : process.env.REACT_APP_SECONDRY_COLOR,
                        color: metalType === "Gold" ? "#fff" : "#000",
                        width: "50%",
                        borderBottomRightRadius: 0,
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 10,
                        borderBottomLeftRadius: 10,
                        textTransform: "none",
                        "&:hover": {
                          background:
                            metalType === "Gold"
                              ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                              : process.env.REACT_APP_SECONDRY_COLOR,
                        },
                      }}
                    >
                      Digital Gold
                    </Button>
                    <Button
                      disableElevation
                      disableRipple
                      onClick={() => {
                        setMetalType("Silver");
                        setAmount(silverPriceWithGst);
                        setSilverGram("2");
                        setSelected(2);
                      }}
                      size="medium"
                      sx={{
                        background:
                          metalType === "Silver"
                            ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                            : process.env.REACT_APP_SECONDRY_COLOR,
                        color: metalType === "Silver" ? "#fff" : "#000",
                        width: "50%",
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 10,
                        borderTopRightRadius: 10,
                        textTransform: "none",
                        "&:hover": {
                          background:
                            metalType === "Silver"
                              ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                              : process.env.REACT_APP_SECONDRY_COLOR,
                        },
                      }}
                    >
                      Digital Silver
                    </Button>
                  </Box>
                </Grid>
                <Grid sx={sxStyleGrid2}>
                  <Grid sx={sxStyleGrid3}>
                    <H4
                      color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                      fontWeight={"500"}
                    >
                      ₹
                      {metalType === "Gold"
                        ? totalGoldAmt ?? "0"
                        : totalSilverAmt ?? "0"}
                    </H4>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textAlign: "center",
                      }}
                      color={"#868686"}
                    >
                      Total Investment
                    </H4>
                  </Grid>
                  <Grid sx={sxStyleGrid4}>
                    <H4
                      color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                      }}
                      fontWeight={"500"}
                    >
                      ₹
                      {metalType === "Gold"
                        ? goldCurrentValue ?? "0"
                        : silverCurrentValue ?? "0"}
                    </H4>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        textAlign: "center",
                      }}
                      color={"#868686"}
                    >
                      Current Amount
                    </H4>
                  </Grid>
                  <Grid sx={sxStyleGrid5}>
                    {metalType === "Gold" ? (
                      <H4
                        color={goldGrowth < 0 ? "#f00" : "#518203"}
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                        fontWeight={"500"}
                      >
                        ₹{goldGrowth < 0 ? "-" : null}
                        {FormatCurrency(goldGrowth ?? "0")}
                      </H4>
                    ) : (
                      <H4
                        color={silverGrowth < 0 ? "#f00" : "#518203"}
                        sx={{
                          width: "100%",
                          textAlign: "center",
                        }}
                        fontWeight={"500"}
                      >
                        ₹{silverGrowth < 0 ? "-" : null}
                        {FormatCurrency(silverGrowth ?? "0")}
                      </H4>
                    )}
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      color={"#868686"}
                    >
                      Returns
                    </H4>
                  </Grid>
                  <Grid sx={sxStyleGrid6}>
                    <H4
                      color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                      sx={{
                        width: "100%",
                        textAlign: "center",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      fontWeight={"500"}
                    >
                      {metalType === "Gold"
                        ? totalGold ?? "0"
                        : totalSilver ?? "0"}{" "}
                      Gm
                    </H4>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                      color={"#868686"}
                    >
                      Weight
                    </H4>
                  </Grid>
                </Grid>
                <Grid sx={sxStyleGrid7}>
                  <H4
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      textAlign: "center",
                    }}
                  >
                    {metalType === "Gold"
                      ? "Gold has delivered an average annual return of 10.9% over the last 10 years"
                      : "Silver's average annual return has been 3.7% over the past decade"}
                  </H4>
                </Grid>
                <Grid
                  xs={16}
                  md={4}
                  sx={{
                    paddingTop: {
                      md: 4,
                      xs: 0,
                      sm: 0,
                    },
                    pl: {
                      md: 4,
                      sm: 1,
                      xs: 0,
                    },
                    mt: {
                      md: 0,
                      sm: 1,
                      xs: 2,
                    },
                    justifyContent: "center",
                    display: {
                      md: "none",
                      xs: "flex",
                    },
                  }}
                >
                  <Box sx={sxStyleBox1}>
                    <H6
                      sx={{
                        mt: 1,
                        pb: 1,
                        fontFamily: "'Poppins', sans-serif",
                        width: "90%",
                      }}
                    >
                      Invest in {metalType}
                    </H6>
                    <Box sx={sxStyleBox3}>
                      <Box
                        sx={{
                          flexDirection: "column",
                          width: {
                            xs: "100%",
                            sm: "100%",
                            md: "50%",
                          },
                        }}
                      >
                        <H4
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          Amount
                        </H4>
                        <TextField
                          name="amount"
                          sx={textInputStyles}
                          InputProps={{
                            style: {
                              height: "35px", // change this value to set the desired height
                            },
                          }}
                          onChange={amountEdit}
                          value={
                            metalType === "Gold" ? goldAmount : silverAmount
                          }
                        />
                      </Box>
                      <Box sx={sxStyleBox4}>
                        <H4
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          Grams
                        </H4>
                        <TextField
                          name="grams"
                          sx={textInputStyles}
                          InputProps={{
                            style: {
                              height: "35px", // change this value to set the desired height
                            },
                          }}
                          value={metalType === "Gold" ? goldGram : silverGram}
                          onChange={grmEdit}
                        />
                      </Box>
                    </Box>
                    {metalType === "Gold" ? (
                      <Grid spacing={2} sx={sxStyleGrid9}>
                        {[1, 3, 5, 10].map((item, index) => (
                          <Box
                            onClick={() => {
                              onButtonSelected(item);
                              setSelected(item);
                            }}
                            sx={{
                              background:
                                item === selected
                                  ? process.env.REACT_APP_PRIMARY_COLOR
                                  : process.env.REACT_APP_SECONDRY_COLOR,
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"500"}
                              sx={{
                                color: item === selected ? "#fff" : "#000",

                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              {item} Gm
                            </Small>
                          </Box>
                        ))}
                      </Grid>
                    ) : (
                      <Grid spacing={2} sx={sxStyleGrid9}>
                        {[2, 10, 50, 100].map((item, index) => (
                          <Box
                            onClick={() => {
                              onButtonSelected(item);
                              setSelected(item);
                            }}
                            sx={{
                              background:
                                item === selected
                                  ? process.env.REACT_APP_PRIMARY_COLOR
                                  : process.env.REACT_APP_SECONDRY_COLOR,
                              borderRadius: 2,
                              p: 1,
                              pt: 0.4,
                              cursor: "pointer",
                            }}
                          >
                            <Small
                              fontWeight={"500"}
                              sx={{
                                color: item === selected ? "#fff" : "#000",

                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              {item} Gm
                            </Small>
                          </Box>
                        ))}
                      </Grid>
                    )}

                    <Small
                      sx={{
                        textAlign: "center",
                        width: "100%",
                        marginY: 0.4,
                      }}
                      fontWeight={"500"}
                    >
                      <Small
                        fontWeight={"500"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {" "}
                        {metalType} live price:{" "}
                      </Small>
                      ₹
                      <Small
                        fontWeight={"500"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        {metalType === "Gold" ? goldLivePrice : silverLivePrice}
                        /Gm
                      </Small>
                    </Small>
                    <Small
                      sx={{
                        textAlign: "center",
                        width: "100%",
                        mt: 0.4,
                        mb: 1,
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Price valid for:{" "}
                      <Small
                        fontWeight={"700"}
                        color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        05:00 min
                      </Small>
                    </Small>
                    <Box sx={sxStyleBox5}>
                      <Box
                        component="img"
                        sx={{
                          height: 15,
                          minwidth: 15,

                          mr: 1,
                          mt: -0.2,
                        }}
                        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/secure.svg"
                        alt="saas-dasboard-footer"
                      />
                      <Small
                        fontWeight={"500"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                        }}
                      >
                        24K {metalType === "Gold" ? "Gold" : "Silver"} with 999
                        Purity
                      </Small>
                    </Box>
                    <Button
                      onClick={confirmInvest}
                      disableElevation
                      disableRipple
                      size="medium"
                      sx={[sxStylebutton, { textTransform: "none" }]}
                    >
                      Invest
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={16} md={4}>
              <Box sx={sxStyleBoxs}>
                <Box sx={sxStyleBox2}>
                  <Button
                    onClick={() => {
                      setMetalType("Gold");
                      setAmount(goldPriceWithGst);
                      setGoldGram("1");
                      setSelected(1);
                    }}
                    disableElevation
                    disableRipple
                    size="medium"
                    sx={{
                      background:
                        metalType === "Gold"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : process.env.REACT_APP_SECONDRY_COLOR,
                      color: metalType === "Gold" ? "#fff" : "#000",
                      width: "50%",
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 0,
                      borderTopLeftRadius: 10,
                      borderBottomLeftRadius: 0,
                      textTransform: "none",
                      p: 1,
                      "&:hover": {
                        background:
                          metalType === "Gold"
                            ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                            : process.env.REACT_APP_SECONDRY_COLOR,
                      },
                    }}
                  >
                    Digital Gold
                  </Button>
                  <Button
                    disableElevation
                    disableRipple
                    onClick={() => {
                      setMetalType("Silver");
                      setAmount(silverPriceWithGst);
                      setSilverGram("2");
                      setSelected(2);
                    }}
                    size="medium"
                    sx={{
                      background:
                        metalType === "Silver"
                          ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                          : process.env.REACT_APP_SECONDRY_COLOR,
                      color: metalType === "Silver" ? "#fff" : "#000",
                      width: "50%",
                      p: 1,
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                      borderBottomRightRadius: 0,
                      borderTopRightRadius: 10,
                      textTransform: "none",
                      "&:hover": {
                        background:
                          metalType === "Silver"
                            ? process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                            : process.env.REACT_APP_SECONDRY_COLOR,
                      },
                    }}
                  >
                    Digital Silver
                  </Button>
                </Box>
                {/* TextInputs */}
                <Box sx={sxStyleBox3}>
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "50%",
                      },
                    }}
                  >
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Amount
                    </H4>
                    <TextField
                      name="amount"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "35px", // change this value to set the desired height
                        },
                      }}
                      onChange={amountEdit}
                      value={metalType === "Gold" ? goldAmount : silverAmount}
                    />
                  </Box>
                  <Box sx={sxStyleBox4}>
                    <H4
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      Grams
                    </H4>
                    <TextField
                      name="grams"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "35px", // change this value to set the desired height
                        },
                      }}
                      value={metalType === "Gold" ? goldGram : silverGram}
                      onChange={grmEdit}
                    />
                  </Box>
                </Box>
                {metalType === "Gold" ? (
                  <Grid spacing={2} sx={sxStyleGrid9}>
                    {[1, 3, 5, 10].map((item, index) => (
                      <Box
                        onClick={() => {
                          onButtonSelected(item);
                          setSelected(item);
                        }}
                        sx={{
                          background:
                            item === selected
                              ? process.env.REACT_APP_PRIMARY_COLOR
                              : process.env.REACT_APP_SECONDRY_COLOR,
                          borderRadius: 2,
                          p: 1,
                          pt: 0.4,
                          cursor: "pointer",
                        }}
                      >
                        <Small
                          fontWeight={"500"}
                          sx={{
                            color: item === selected ? "#fff" : "#000",

                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item} Gm
                        </Small>
                      </Box>
                    ))}
                  </Grid>
                ) : (
                  <Grid spacing={2} sx={sxStyleGrid9}>
                    {[2, 10, 50, 100].map((item, index) => (
                      <Box
                        onClick={() => {
                          onButtonSelected(item);
                          setSelected(item);
                        }}
                        sx={{
                          background:
                            item === selected
                              ? process.env.REACT_APP_PRIMARY_COLOR
                              : process.env.REACT_APP_SECONDRY_COLOR,
                          borderRadius: 2,
                          p: 1,
                          pt: 0.4,
                          cursor: "pointer",
                        }}
                      >
                        <Small
                          fontWeight={"500"}
                          sx={{
                            color: item === selected ? "#fff" : "#000",

                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item} Gm
                        </Small>
                      </Box>
                    ))}
                  </Grid>
                )}

                <Small
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    marginY: 0.4,
                  }}
                  fontWeight={"500"}
                >
                  <Small
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {" "}
                    {metalType} live price:{" "}
                  </Small>
                  ₹
                  <Small
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    {metalType === "Gold" ? goldLivePrice : silverLivePrice}
                    /Gm
                  </Small>
                </Small>
                <Small
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    mt: 0.4,
                    mb: 1,
                    fontFamily: "'Poppins', sans-serif",
                  }}
                >
                  Price valid for:{" "}
                  <Small
                    fontWeight={"700"}
                    color={process.env.REACT_APP_BUTTON_ACTIVE_COLOR}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    05:00 min
                  </Small>
                </Small>
                <Box sx={sxStyleBox5}>
                  <Box
                    component="img"
                    sx={{
                      height: 15,
                      minwidth: 15,

                      mr: 1,
                      mt: -0.2,
                    }}
                    src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/secure.svg"
                    alt="saas-dasboard-footer"
                  />
                  <Small
                    fontWeight={"500"}
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                    }}
                  >
                    24K {metalType === "Gold" ? "Gold" : "Silver"} with 999
                    Purity
                  </Small>
                </Box>
                <Button
                  onClick={confirmInvest}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={[sxStylebutton, { textTransform: "none" }]}
                >
                  Invest
                </Button>
              </Box>
            </Grid>
          </Grid>
          <H3 sx={sxStyleH31}>Explore</H3>
          <Grid container columns={16} spacing={0} sx={sxStyleGrid10}>
            {GOLD_SILVER_CATEGORY_TILES.map((item, index) => (
              <GradientCard
                onPress={() => onCardPress(item.name)}
                bgColor={item.bgColor}
                image={item.icon}
                heading={item.name}
                subheading={item.subheading}
              />
            ))}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default DigitalGoldTabScreen;
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "94%",
  },
  marginTop: {
    xs: 0.5,
    sm: 2,
    md: 0.5,
  },
  padding: 0.1,
};

const sxStyleGrid = {
  padding: {
    md: 2,
    xs: 0,
    sm: 0,
  },
  pr: {
    md: 2,
    xs: 0,
  },
  pl: {
    md: 2,
    xs: 2,
  },
  height: "100%",
  mt: {
    md: 2,
    xs: 0,
  },
};

const sxStyleGrid1 = {
  pt: 0.5,
  pb: 2.5,
  justifyContent: {
    md: "flex-start",
    xs: "center",
    sm: "center",
  },
  paddingLeft: {
    md: 4,
    xs: 1,
    sm: 1,
  },
  paddingRight: {
    md: 0,
    xs: 1,
    sm: 1,
  },
  mt: {
    xs: 3,
    sm: 3,
    md: 1,
  },
};
const sxStyleGrid2 = {
  display: "flex",
  borderTop: 0.2,
  borderBottom: 1,
  borderColor: "#EEEEEE",
  marginTop: 2,
};
const sxStyleGrid3 = {
  width: {
    md: "25%",
    xs: "33.33%",
  },
  alignItems: "center",
  justifyContent: "center",
  display: {
    md: "flex",
    xs: "none",
  },
  flexDirection: "column",
  borderTopColor: "#EEEEEE",
  borderTopWidth: 0.2,
  mt: 0.5,
  mb: 0.5,
};
const sxStyleGrid4 = {
  width: {
    md: "25%",
    xs: "33.33%",
  },
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",

  borderLeftWidth: "1px", // set the left border width to 2 pixels
  borderLeftStyle: "solid", // set the left border style to solid
  borderLeftColor: "#EEEEEE", // set the left border color

  pt: 2,
  pb: 2,
};
const sxStyleGrid5 = {
  width: {
    md: "25%",
    xs: "33.33%",
  },
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
  borderColor: "#EEEEEE",
  borderLeft: 1,
  borderLeftColor: "#EEEEEE",
};
const sxStyleGrid6 = {
  width: {
    md: "25%",
    xs: "33.33%",
  },
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
  borderLeft: 1,
  borderLeftColor: "#EEEEEE",
};
const sxStyleGrid7 = {
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  display: {
    md: "flex",
    xs: "none",
  },
  flexDirection: "column",
  minHeight: 50,
  p: 5,
};

const sxStyleGrid9 = {
  flexDirection: "row",
  display: "flex",
  justifyContent: "space-around",
  alignItems: "stretch",
  width: "100%",
  alignSelf: "center",
  padddingY: 20,
  pb: 1,
};
const sxStyleGrid10 = {
  cursor: "pointer",
  flexGrow: 1,
  mt: {
    md: 2,
    xs: 0.5,
  },
  mb: 2,
  pb: 2,
  ml: 0.5,
  justifyContent: "space-between",
  alignItems: "stretch",
};

const sxStyleH31 = {
  fontFamily: "'Poppins', sans-serif",
  mt: {
    md: 0,
    sm: 1,
    xs: 2,
  },
};
const sxStyleBox = {
  width: {
    md: "40%",
  },
  borderRadius: 2,
  mt: 2,
};
const sxStyleBox1 = {
  width: {
    md: "100%",
    xs: "100%",
    sm: "100%",
  },
  borderRadius: 2,
  pb: 1,
  mt: {
    md: 5,
    xs: 0,
  },
  background: "white",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
};
const sxStyleBoxs = {
  display: {
    md: "flex",
    xs: "none",
  },
  width: {
    md: "100%",
    xs: "100%",
    sm: "100%",
  },
  borderRadius: 2,
  pb: 1,
  mt: {
    md: 5,
    xs: 0,
  },
  background: "white",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
};
const sxStyleBox2 = {
  width: "100%",
  borderRadius: 2,
  pb: 1,
  display: {
    md: "flex",
    xs: "none",
  },
  flexDirection: "row",
};
const sxStyleBox3 = {
  flexDirection: {
    md: "row",
    xs: "column",
  },
  display: "flex",
  paddingX: 2,
  paddingY: 0.5,
  pb: 2,
  width: "90%",
};
const sxStyleBox4 = {
  flexDirection: "column",
  width: {
    xs: "100%",
    sm: "100%",
    md: "50%",
  },
  mt: {
    md: 0,
    sm: 1,
    xs: 1,
  },
};
const sxStyleBox5 = {
  background:
    "linear-gradient(150.93deg, #FFF3DB 24.82%, rgba(246, 255, 228, 0) 83.94%)",
  p: 0.7,
  pl: 2,
  pr: 2,
  borderRadius: 2,
  flexDirection: "row",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  mt: 0.2,
  mb: 1,
};
const sxStylebutton = {
  background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
  color: "#fff",
  width: "50%",
  mb: 1,
};
